export enum SubDealersQueryKeys {
  All = "allSubDealers",
  Players = "subDealers.players",
  GetPlayers = "subDealers.getPlayers",
  SubDealer = "subDealers.subDealer",
}
